import { Apple, Smartphone, Clock, MapPin, Bell } from "lucide-react";

export default function MobileApp() {
  return (
    <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-testid="mobile-app-section">
      <div className="absolute inset-0 dot-grid opacity-10 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-white/10 text-white text-[10px] font-bold uppercase tracking-[0.2em] mb-3">
              Coming Soon · iOS + Android
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
              File a claim in <span className="text-[#FF7A00]">60 seconds.</span><br />
              Track in real time.
            </h2>
            <p className="mt-4 text-slate-300 max-w-lg">
              Get the mobile experience — instant accident reporting, AI photo damage estimator, push-notification status,
              and one-tap towing. Drop your email and we'll send you the link the day we launch.
            </p>

            <form
              className="mt-6 flex flex-col sm:flex-row gap-2 max-w-md"
              onSubmit={(e) => e.preventDefault()}
              data-testid="mobile-waitlist-form"
            >
              <input
                type="email"
                placeholder="you@email.com"
                className="flex-1 px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#FF7A00]"
                data-testid="mobile-waitlist-email"
              />
              <button
                type="submit"
                className="bg-[#FF7A00] hover:bg-[#CC6200] text-white rounded-xl px-5 py-3 font-semibold transition-colors"
                data-testid="mobile-waitlist-submit"
              >
                Notify Me
              </button>
            </form>

            <div className="mt-8 flex flex-wrap gap-4 text-sm text-slate-300">
              <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#FF7A00]" /> 60-sec claim</div>
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#00A86B]" /> Live tracking</div>
              <div className="flex items-center gap-2"><Bell className="w-4 h-4 text-[#3B82F6]" /> Push updates</div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-[#003DA5] to-[#0050D1] rounded-3xl p-8 shadow-2xl">
              <div className="bg-slate-900 rounded-2xl p-6 border border-white/10">
                <div className="flex items-center justify-between mb-4">
                  <div className="text-xs font-bold uppercase tracking-wider text-slate-400">Active Claim</div>
                  <div className="px-2 py-0.5 rounded-full bg-[#00A86B] text-[10px] font-bold uppercase tracking-wider">
                    On Track
                  </div>
                </div>
                <div className="font-heading text-2xl font-extrabold">MIC260615A8F2</div>
                <div className="text-slate-400 text-sm mb-5">Hyundai Creta · ICICI Lombard</div>
                <div className="space-y-2.5">
                  {["Registered", "Survey Done", "Approved", "Repair Started"].map((s, i) => (
                    <div key={s} className="flex items-center gap-3">
                      <div className={`w-2.5 h-2.5 rounded-full ${i < 3 ? "bg-[#00A86B]" : "bg-[#FF7A00] animate-pulse"}`} />
                      <div className={`text-sm ${i < 3 ? "text-slate-200" : "text-white font-semibold"}`}>{s}</div>
                    </div>
                  ))}
                </div>
                <div className="mt-5 p-3 rounded-xl bg-white/5 border border-white/10">
                  <div className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Estimated Settlement</div>
                  <div className="font-heading font-extrabold text-2xl">7 days</div>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-[#FF7A00]/30 blur-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
